const GridAddendum = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 411.04 59.16"
    className="grid-svg grid-addendum"
  >
    <g>
      <g>
        <path
          d="M15.76,5.82h2.21V0.45h3.89v5.38h2.86v2.86h-2.86v7.7c0,0.48,0,1.26,1.96,1.26c0.22,0,0.28,0,1.09-0.08v3.05
			c-1.6,0.2-1.76,0.22-2.35,0.22c-1.68,0-4.59-0.22-4.59-4.06V8.68h-2.21V5.82z"
        />
        <path
          d="M33.54,5.38c1.65,0,3.78,0.14,5.1,2.27c0.73,1.2,0.92,2.88,0.92,5.54c0,3.05-0.06,4.79-1.6,6.3
			c-0.5,0.48-1.43,1.4-4.06,1.4c-0.9,0-2.46-0.06-3.42-0.59c-2.49-1.4-2.63-3.84-2.63-7.45C27.86,10.05,27.86,5.38,33.54,5.38z
			 M31.84,14.22c0,0.53,0.08,1.9,0.2,2.38c0.31,1.34,1.43,1.34,1.71,1.34c1.88,0,1.88-1.32,1.88-5.32c0-2.32,0-4.28-1.85-4.28
			c-1.93,0-1.93,1.82-1.93,2.97V14.22z"
        />
        <path
          d="M57.46,10.22c-0.06-0.78-0.2-1.68-1.6-1.68c-1.85,0-1.85,1.76-1.85,2.6v4.34c0,1.85,0.39,2.52,1.9,2.52
			c1.32,0,1.65-0.95,1.65-2.13h3.36c-0.06,1.51-0.14,5.18-5.12,5.18c-0.78,0-2.66,0-4-1.23c-1.32-1.18-1.74-2.97-1.74-4.73v-3.5
			c0-3.47,1.37-6.16,5.38-6.16c0.92,0,2.94,0.03,4.23,1.62c0.92,1.12,0.92,2.27,0.95,3.16H57.46z"
        />
        <path d="M63.98,5.82h3.75v3.36h0.11c1.4-3.25,3-3.7,4.42-3.75v5.12c-1.65,0-2.69,0-4.28,1.34v8.76h-4V5.82z" />
        <path
          d="M77.95,14.06c-0.03,1.51-0.03,4.06,2.72,4.06c1.2,0,2.18-0.22,3.95-1.09l0.42,2.97c-1.51,0.53-2.74,0.98-4.7,0.98
			c-1.82,0-4.82-0.39-5.71-3.81c-0.28-1.09-0.36-2.86-0.36-2.97c0-2.6,0-5.04,1.01-6.69c1.15-1.9,3.33-2.1,4.54-2.1
			c2.41,0,3.56,1.01,4.28,2.1c0.9,1.32,0.9,2.72,0.9,6.55H77.95z M81.73,11.84c0-2.24-0.03-3.95-1.99-3.95
			c-1.85,0-1.82,2.07-1.79,3.95H81.73z"
        />
        <path
          d="M87.53,7.42c1.26-0.98,2.52-1.96,5.68-1.96c1.04,0,3.25,0.25,4.45,1.46c1.12,1.12,1.12,2.24,1.12,3.02v7.28
			c0,0.08,0.11,0.9,0.87,0.92v2.69H98.5c-1.9,0-2.69-1.18-3.05-1.85h-0.11c-0.48,0.62-0.76,0.95-1.37,1.32
			c-0.2,0.11-1.29,0.76-2.58,0.76c-1.57,0-3.98-0.81-3.98-4.23c0-1.37,0.5-3.56,3.19-4.79c1.43-0.64,2.94-0.95,4.26-1.04
			c0-1.46,0-1.88-0.28-2.27c-0.25-0.36-0.87-0.64-1.62-0.64c-1.71,0-2.77,0.92-3.58,1.62L87.53,7.42z M94.83,13.08
			c-0.87,0.17-3.7,0.7-3.7,3.25c0,1.01,0.62,1.82,1.57,1.82c1.79,0,2.13-1.79,2.13-2.77V13.08z"
        />
        <path
          d="M100.85,5.82h2.21V0.45h3.89v5.38h2.86v2.86h-2.86v7.7c0,0.48,0,1.26,1.96,1.26c0.22,0,0.28,0,1.09-0.08v3.05
			c-1.6,0.2-1.76,0.22-2.35,0.22c-1.68,0-4.59-0.22-4.59-4.06V8.68h-2.21V5.82z"
        />
        <path
          d="M116,14.06c-0.03,1.51-0.03,4.06,2.72,4.06c1.2,0,2.18-0.22,3.95-1.09l0.42,2.97c-1.51,0.53-2.74,0.98-4.7,0.98
			c-1.82,0-4.82-0.39-5.71-3.81c-0.28-1.09-0.36-2.86-0.36-2.97c0-2.6,0-5.04,1.01-6.69c1.15-1.9,3.33-2.1,4.54-2.1
			c2.41,0,3.56,1.01,4.28,2.1c0.9,1.32,0.9,2.72,0.9,6.55H116z M119.78,11.84c0-2.24-0.03-3.95-1.99-3.95
			c-1.85,0-1.82,2.07-1.79,3.95H119.78z"
        />
        <path
          d="M136.83,5.82l2.13,7.31h0.22l1.82-7.31h3.84l-3.7,13.75c-1.37,5.07-2.97,5.99-6.02,5.99c-0.95,0-1.26-0.06-1.93-0.2v-3.3
			l1.43,0.17c1.37,0,1.85-0.7,2.04-1.01c0.5-0.76,0.5-1.15,0.5-2.02l-4.23-13.38H136.83z"
        />
        <path
          d="M152.37,5.38c1.65,0,3.78,0.14,5.1,2.27c0.73,1.2,0.92,2.88,0.92,5.54c0,3.05-0.06,4.79-1.6,6.3
			c-0.5,0.48-1.43,1.4-4.06,1.4c-0.9,0-2.46-0.06-3.42-0.59c-2.49-1.4-2.63-3.84-2.63-7.45C146.69,10.05,146.69,5.38,152.37,5.38z
			 M150.67,14.22c0,0.53,0.08,1.9,0.2,2.38c0.31,1.34,1.43,1.34,1.71,1.34c1.88,0,1.88-1.32,1.88-5.32c0-2.32,0-4.28-1.85-4.28
			c-1.93,0-1.93,1.82-1.93,2.97V14.22z"
        />
        <path
          d="M173.68,5.82v14.84h-3.58v-2.52h-0.17c-0.84,1.4-1.9,2.88-4.28,2.88c-3.53,0-3.67-2.91-3.67-3.95V5.82h3.92v9.66
			c0,1.01,0.22,2.07,1.34,2.07c0.45,0,1.06-0.28,1.26-0.39c0.7-0.39,1.04-0.87,1.26-1.15V5.82H173.68z"
        />
        <path d="M176.96,5.82h3.75v3.36h0.11c1.4-3.25,3-3.7,4.42-3.75v5.12c-1.65,0-2.69,0-4.28,1.34v8.76h-4V5.82z" />
        <path
          d="M200.98,5.38c1.65,0,3.78,0.14,5.1,2.27c0.73,1.2,0.92,2.88,0.92,5.54c0,3.05-0.06,4.79-1.6,6.3
			c-0.5,0.48-1.43,1.4-4.06,1.4c-0.9,0-2.46-0.06-3.42-0.59c-2.49-1.4-2.63-3.84-2.63-7.45C195.3,10.05,195.3,5.38,200.98,5.38z
			 M199.27,14.22c0,0.53,0.08,1.9,0.2,2.38c0.31,1.34,1.43,1.34,1.71,1.34c1.88,0,1.88-1.32,1.88-5.32c0-2.32,0-4.28-1.85-4.28
			c-1.93,0-1.93,1.82-1.93,2.97V14.22z"
        />
        <path
          d="M219.69,5.82l1.65,6.22c0.11,0.36,0.53,2.04,0.62,2.38h0.11c0.22-1.06,0.31-1.4,0.56-2.46l1.46-6.13h3.5l-3.95,14.84
			h-2.97l-1.76-6.69c-0.25-0.95-0.36-1.4-0.56-2.27h-0.14c-0.2,0.76-0.36,1.34-0.59,2.24l-1.68,6.72h-3.02l-4.06-14.84h3.47
			l1.46,6.02c0.36,1.54,0.42,1.71,0.64,2.58h0.17c0.17-0.73,0.28-1.32,0.42-1.85c0.08-0.25,0.2-0.67,0.25-0.92l1.46-5.82H219.69z"
        />
        <path
          d="M229.96,5.82h3.64v2.74h0.08c0.87-1.6,2.3-3.05,4.26-3.05c3.75,0,3.75,3.16,3.75,4.28v10.86h-3.95v-9.69
			c0-0.59,0.03-2.02-1.29-2.02c-1.12,0-1.79,0.73-2.55,1.54v10.16h-3.95V5.82z"
        />
        <path
          d="M264.37,5.82v14.84h-3.58v-2.52h-0.17c-0.84,1.4-1.9,2.88-4.28,2.88c-3.53,0-3.67-2.91-3.67-3.95V5.82h3.92v9.66
			c0,1.01,0.22,2.07,1.34,2.07c0.45,0,1.06-0.28,1.26-0.39c0.7-0.39,1.04-0.87,1.26-1.15V5.82H264.37z"
        />
        <path
          d="M267.96,5.82h3.64v2.74h0.08c0.87-1.6,2.3-3.05,4.26-3.05c3.75,0,3.75,3.16,3.75,4.28v10.86h-3.95v-9.69
			c0-0.59,0.03-2.02-1.29-2.02c-1.12,0-1.79,0.73-2.55,1.54v10.16h-3.95V5.82z"
        />
        <path d="M287.14,3.36h-3.86V0h3.86V3.36z M283.27,5.82h3.86v14.84h-3.86V5.82z" />
        <path
          d="M302.03,5.68v19.82h-3.95v-6.89h-0.2c-0.42,0.64-1.43,2.18-3.72,2.18c-2.07,0-3.44-1.04-3.72-3.42
			c-0.03-0.22-0.03-0.36-0.06-1.65c0-0.28-0.06-1.54-0.06-1.82c0-0.34,0-4.14,0.34-5.66c0.17-0.67,0.76-2.88,3.44-2.88
			c1.93,0,3.25,0.92,4.06,2.66h0.25V5.68H302.03z M298.09,9.91c-0.42-0.5-1.29-1.06-2.16-1.06c-1.48,0-1.6,1.15-1.6,3.7
			c0,0.98,0,3.25,0.03,3.53c0.03,0.39,0.14,1.62,1.51,1.62c0.87,0,1.57-0.59,2.21-1.37V9.91z"
        />
        <path
          d="M317.74,5.82v14.84h-3.58v-2.52h-0.17c-0.84,1.4-1.9,2.88-4.28,2.88c-3.53,0-3.67-2.91-3.67-3.95V5.82h3.92v9.66
			c0,1.01,0.22,2.07,1.34,2.07c0.45,0,1.06-0.28,1.26-0.39c0.7-0.39,1.04-0.87,1.26-1.15V5.82H317.74z"
        />
        <path
          d="M324.38,14.06c-0.03,1.51-0.03,4.06,2.72,4.06c1.2,0,2.18-0.22,3.95-1.09l0.42,2.97c-1.51,0.53-2.74,0.98-4.7,0.98
			c-1.82,0-4.82-0.39-5.71-3.81c-0.28-1.09-0.36-2.86-0.36-2.97c0-2.6,0-5.04,1.01-6.69c1.15-1.9,3.33-2.1,4.54-2.1
			c2.41,0,3.56,1.01,4.28,2.1c0.9,1.32,0.9,2.72,0.9,6.55H324.38z M328.16,11.84c0-2.24-0.03-3.95-1.99-3.95
			c-1.85,0-1.82,2.07-1.79,3.95H328.16z"
        />
        <path
          d="M342.41,5.68h3.64v2.35h0.22c0.84-1.79,2.21-2.66,3.98-2.66c2.52,0,3.25,1.74,3.53,2.88c0.31,1.26,0.31,3.42,0.31,5.66
			c0,3.3,0,4.31-0.73,5.43c-0.53,0.81-1.43,1.46-3.08,1.46c-1.79,0-2.94-0.98-3.72-2.18h-0.2v6.89h-3.95V5.68z M346.36,16.6
			c0.64,0.5,1.34,1.09,2.21,1.09c1.57,0,1.57-1.2,1.57-3.98c0-0.5-0.06-3.02-0.11-3.39c-0.2-1.43-1.01-1.48-1.48-1.48
			c-0.98,0-1.71,0.56-2.18,1.06V16.6z"
        />
        <path d="M357.45,5.82h3.75v3.36h0.11c1.4-3.25,3-3.7,4.42-3.75v5.12c-1.65,0-2.69,0-4.28,1.34v8.76h-4V5.82z" />
        <path d="M372.26,3.36h-3.86V0h3.86V3.36z M368.39,5.82h3.86v14.84h-3.86V5.82z" />
        <path
          d="M375.87,5.82h3.64v2.74h0.08c0.87-1.6,2.3-3.05,4.26-3.05c3.75,0,3.75,3.16,3.75,4.28v10.86h-3.95v-9.69
			c0-0.59,0.03-2.02-1.29-2.02c-1.12,0-1.79,0.73-2.55,1.54v10.16h-3.95V5.82z"
        />
        <path
          d="M389.67,5.82h2.21V0.45h3.89v5.38h2.86v2.86h-2.86v7.7c0,0.48,0,1.26,1.96,1.26c0.22,0,0.28,0,1.09-0.08v3.05
			c-1.6,0.2-1.76,0.22-2.35,0.22c-1.68,0-4.59-0.22-4.59-4.06V8.68h-2.21V5.82z"
        />
        <path d="M3.86,36.96H0V33.6h3.86V36.96z M0,39.42h3.86v14.84H0V39.42z" />
        <path
          d="M7.48,39.42h3.64v2.74h0.08c0.87-1.6,2.3-3.05,4.26-3.05c3.75,0,3.75,3.16,3.75,4.28v10.86h-3.95v-9.69
			c0-0.59,0.03-2.02-1.29-2.02c-1.12,0-1.79,0.73-2.55,1.54v10.16H7.48V39.42z"
        />
        <path
          d="M37.07,43.82c-0.06-0.78-0.2-1.68-1.6-1.68c-1.85,0-1.85,1.76-1.85,2.6v4.34c0,1.85,0.39,2.52,1.9,2.52
			c1.32,0,1.65-0.95,1.65-2.13h3.36c-0.06,1.51-0.14,5.18-5.12,5.18c-0.78,0-2.66,0-4-1.23c-1.32-1.18-1.74-2.97-1.74-4.73v-3.5
			c0-3.47,1.37-6.16,5.38-6.16c0.92,0,2.94,0.03,4.23,1.62c0.92,1.12,0.92,2.27,0.95,3.16H37.07z"
        />
        <path
          d="M49.59,38.98c1.65,0,3.78,0.14,5.1,2.27c0.73,1.2,0.92,2.88,0.92,5.54c0,3.05-0.06,4.79-1.6,6.3
			c-0.5,0.48-1.43,1.4-4.06,1.4c-0.9,0-2.46-0.06-3.42-0.59c-2.49-1.4-2.63-3.84-2.63-7.45C43.9,43.65,43.9,38.98,49.59,38.98z
			 M47.88,47.82c0,0.53,0.08,1.9,0.2,2.38c0.31,1.34,1.43,1.34,1.71,1.34c1.88,0,1.88-1.32,1.88-5.32c0-2.32,0-4.28-1.85-4.28
			c-1.93,0-1.93,1.82-1.93,2.97V47.82z"
        />
        <path d="M59.19,33.71h3.95v20.55h-3.95V33.71z" />
        <path d="M66.7,33.71h3.95v20.55H66.7V33.71z" />
        <path
          d="M73.11,41.02c1.26-0.98,2.52-1.96,5.68-1.96c1.04,0,3.25,0.25,4.45,1.46c1.12,1.12,1.12,2.24,1.12,3.02v7.28
			c0,0.08,0.11,0.9,0.87,0.92v2.69h-1.15c-1.9,0-2.69-1.18-3.05-1.85h-0.11c-0.48,0.62-0.76,0.95-1.37,1.32
			c-0.2,0.11-1.29,0.76-2.58,0.76c-1.57,0-3.98-0.81-3.98-4.23c0-1.37,0.5-3.56,3.19-4.79c1.43-0.64,2.94-0.95,4.26-1.04
			c0-1.46,0-1.88-0.28-2.27c-0.25-0.36-0.87-0.64-1.62-0.64c-1.71,0-2.77,0.92-3.58,1.62L73.11,41.02z M80.42,46.68
			c-0.87,0.17-3.7,0.7-3.7,3.25c0,1.01,0.62,1.82,1.57,1.82c1.79,0,2.13-1.79,2.13-2.77V46.68z"
        />
        <path
          d="M87.81,33.71h3.95v7.53h0.08c1.88-2.21,3.25-2.24,3.98-2.24c3.53,0,3.75,3.3,3.75,5.6l0.03,2.27
			c0,1.68-0.03,3.08-0.2,4.26c-0.11,0.7-0.67,3.36-3.81,3.36c-1.74,0-3.05-1.04-3.92-2.63H91.5v2.41h-3.7V33.71z M91.76,49.87
			c0.36,0.39,1.06,1.15,2.21,1.15c1.57,0,1.62-1.37,1.62-4.37c0-3.36-0.06-4.54-1.54-4.54c-0.73,0-1.15,0.22-2.3,1.12V49.87z"
        />
        <path
          d="M108.89,38.98c1.65,0,3.78,0.14,5.1,2.27c0.73,1.2,0.92,2.88,0.92,5.54c0,3.05-0.06,4.79-1.6,6.3
			c-0.5,0.48-1.43,1.4-4.06,1.4c-0.9,0-2.46-0.06-3.42-0.59c-2.49-1.4-2.63-3.84-2.63-7.45C103.21,43.65,103.21,38.98,108.89,38.98z
			 M107.18,47.82c0,0.53,0.08,1.9,0.2,2.38c0.31,1.34,1.43,1.34,1.71,1.34c1.88,0,1.88-1.32,1.88-5.32c0-2.32,0-4.28-1.85-4.28
			c-1.93,0-1.93,1.82-1.93,2.97V47.82z"
        />
        <path d="M118.19,39.42h3.75v3.36h0.11c1.4-3.25,3-3.7,4.42-3.75v5.12c-1.65,0-2.69,0-4.28,1.34v8.76h-4V39.42z" />
        <path
          d="M128.02,41.02c1.26-0.98,2.52-1.96,5.68-1.96c1.04,0,3.25,0.25,4.45,1.46c1.12,1.12,1.12,2.24,1.12,3.02v7.28
			c0,0.08,0.11,0.9,0.87,0.92v2.69h-1.15c-1.9,0-2.69-1.18-3.05-1.85h-0.11c-0.48,0.62-0.76,0.95-1.37,1.32
			c-0.2,0.11-1.29,0.76-2.58,0.76c-1.57,0-3.98-0.81-3.98-4.23c0-1.37,0.5-3.56,3.19-4.79c1.43-0.64,2.94-0.95,4.26-1.04
			c0-1.46,0-1.88-0.28-2.27c-0.25-0.36-0.87-0.64-1.62-0.64c-1.71,0-2.77,0.92-3.58,1.62L128.02,41.02z M135.32,46.68
			c-0.87,0.17-3.7,0.7-3.7,3.25c0,1.01,0.62,1.82,1.57,1.82c1.79,0,2.13-1.79,2.13-2.77V46.68z"
        />
        <path
          d="M141.34,39.42h2.21v-5.38h3.89v5.38h2.86v2.86h-2.86v7.7c0,0.48,0,1.26,1.96,1.26c0.22,0,0.28,0,1.09-0.08v3.05
			c-1.6,0.2-1.76,0.22-2.35,0.22c-1.68,0-4.59-0.22-4.59-4.06v-8.09h-2.21V39.42z"
        />
        <path d="M157.33,36.96h-3.86V33.6h3.86V36.96z M153.47,39.42h3.86v14.84h-3.86V39.42z" />
        <path
          d="M166.63,38.98c1.65,0,3.78,0.14,5.1,2.27c0.73,1.2,0.92,2.88,0.92,5.54c0,3.05-0.06,4.79-1.6,6.3
			c-0.5,0.48-1.43,1.4-4.06,1.4c-0.9,0-2.46-0.06-3.42-0.59c-2.49-1.4-2.63-3.84-2.63-7.45C160.94,43.65,160.94,38.98,166.63,38.98z
			 M164.92,47.82c0,0.53,0.08,1.9,0.2,2.38c0.31,1.34,1.43,1.34,1.71,1.34c1.88,0,1.88-1.32,1.88-5.32c0-2.32,0-4.28-1.85-4.28
			c-1.93,0-1.93,1.82-1.93,2.97V47.82z"
        />
        <path
          d="M176.23,39.42h3.64v2.74h0.08c0.87-1.6,2.3-3.05,4.26-3.05c3.75,0,3.75,3.16,3.75,4.28v10.86h-3.95v-9.69
			c0-0.59,0.03-2.02-1.29-2.02c-1.12,0-1.79,0.73-2.55,1.54v10.16h-3.95V39.42z"
        />
        <path
          d="M208.6,39.42l1.65,6.22c0.11,0.36,0.53,2.04,0.62,2.38h0.11c0.22-1.06,0.31-1.4,0.56-2.46l1.46-6.13h3.5l-3.95,14.84
			h-2.97l-1.76-6.69c-0.25-0.95-0.36-1.4-0.56-2.27h-0.14c-0.2,0.76-0.36,1.34-0.59,2.24l-1.68,6.72h-3.02l-4.06-14.84h3.47
			l1.46,6.02c0.36,1.54,0.42,1.71,0.64,2.58h0.17c0.17-0.73,0.28-1.32,0.42-1.85c0.08-0.25,0.2-0.67,0.25-0.92l1.46-5.82H208.6z"
        />
        <path d="M222.77,36.96h-3.86V33.6h3.86V36.96z M218.9,39.42h3.86v14.84h-3.86V39.42z" />
        <path
          d="M224.89,39.42h2.21v-5.38H231v5.38h2.86v2.86H231v7.7c0,0.48,0,1.26,1.96,1.26c0.22,0,0.28,0,1.09-0.08v3.05
			c-1.6,0.2-1.76,0.22-2.35,0.22c-1.68,0-4.59-0.22-4.59-4.06v-8.09h-2.21V39.42z"
        />
        <path
          d="M236.99,33.71h3.95v6.02l-0.06,2.02h0.17c1.12-1.99,2.58-2.69,4.12-2.69c1.18,0,2.24,0.48,2.88,1.46
			c0.67,1.01,0.67,2.16,0.67,3.08v10.67h-3.92v-9.55c0-0.9-0.03-2.21-1.34-2.21c-0.92,0-1.43,0.48-2.52,1.46v10.3h-3.95V33.71z"
        />
        <path
          d="M260.43,33.71h6.78c3.02,0,4.65,0.64,5.74,1.62c1.29,1.15,1.88,2.8,1.88,4.84c0,3.19-1.76,4.7-2.69,5.26
			c-1.48,0.9-3.11,0.98-4.7,1.04l-2.46,0.08v7.7h-4.54V33.71z M264.96,43.12c2.16,0,2.97,0,3.5-0.22c0.36-0.14,1.65-0.76,1.65-2.86
			c0-1.99-0.76-2.41-1.37-2.66c-0.73-0.28-1.06-0.28-3.78-0.28V43.12z"
        />
        <path
          d="M280.59,47.66c-0.03,1.51-0.03,4.06,2.72,4.06c1.2,0,2.18-0.22,3.95-1.09l0.42,2.97c-1.51,0.53-2.74,0.98-4.7,0.98
			c-1.82,0-4.82-0.39-5.71-3.81c-0.28-1.09-0.36-2.86-0.36-2.97c0-2.6,0-5.04,1.01-6.69c1.15-1.9,3.33-2.1,4.54-2.1
			c2.41,0,3.56,1.01,4.28,2.1c0.9,1.32,0.9,2.72,0.9,6.55H280.59z M284.37,45.44c0-2.24-0.03-3.95-1.99-3.95
			c-1.85,0-1.82,2.07-1.79,3.95H284.37z"
        />
        <path
          d="M289.77,39.42h2.21v-5.38h3.89v5.38h2.86v2.86h-2.86v7.7c0,0.48,0,1.26,1.96,1.26c0.22,0,0.28,0,1.09-0.08v3.05
			c-1.6,0.2-1.76,0.22-2.35,0.22c-1.68,0-4.59-0.22-4.59-4.06v-8.09h-2.21V39.42z"
        />
        <path
          d="M304.92,47.66c-0.03,1.51-0.03,4.06,2.72,4.06c1.2,0,2.18-0.22,3.95-1.09l0.42,2.97c-1.51,0.53-2.74,0.98-4.7,0.98
			c-1.82,0-4.82-0.39-5.71-3.81c-0.28-1.09-0.36-2.86-0.36-2.97c0-2.6,0-5.04,1.01-6.69c1.15-1.9,3.33-2.1,4.54-2.1
			c2.41,0,3.56,1.01,4.28,2.1c0.9,1.32,0.9,2.72,0.9,6.55H304.92z M308.7,45.44c0-2.24-0.03-3.95-1.99-3.95
			c-1.85,0-1.82,2.07-1.79,3.95H308.7z"
        />
        <path d="M315.28,39.42h3.75v3.36h0.11c1.4-3.25,3-3.7,4.42-3.75v5.12c-1.65,0-2.69,0-4.28,1.34v8.76h-4V39.42z" />
        <path d="M334.32,33.71h4.56v7.78h5.77v-7.78h4.62v20.55h-4.54v-8.88h-5.82v8.88h-4.59V33.71z" />
        <path
          d="M352.46,41.02c1.26-0.98,2.52-1.96,5.68-1.96c1.04,0,3.25,0.25,4.45,1.46c1.12,1.12,1.12,2.24,1.12,3.02v7.28
			c0,0.08,0.11,0.9,0.87,0.92v2.69h-1.15c-1.9,0-2.69-1.18-3.05-1.85h-0.11c-0.48,0.62-0.76,0.95-1.37,1.32
			c-0.2,0.11-1.29,0.76-2.58,0.76c-1.57,0-3.98-0.81-3.98-4.23c0-1.37,0.5-3.56,3.19-4.79c1.43-0.64,2.94-0.95,4.26-1.04
			c0-1.46,0-1.88-0.28-2.27c-0.25-0.36-0.87-0.64-1.62-0.64c-1.71,0-2.77,0.92-3.58,1.62L352.46,41.02z M359.77,46.68
			c-0.87,0.17-3.7,0.7-3.7,3.25c0,1.01,0.62,1.82,1.57,1.82c1.79,0,2.13-1.79,2.13-2.77V46.68z"
        />
        <path d="M367.27,33.71h3.95v20.55h-3.95V33.71z" />
        <path d="M374.78,33.71h3.95v20.55h-3.95V33.71z" />
        <path
          d="M385.33,47.66c-0.03,1.51-0.03,4.06,2.72,4.06c1.2,0,2.18-0.22,3.95-1.09l0.42,2.97c-1.51,0.53-2.74,0.98-4.7,0.98
			c-1.82,0-4.82-0.39-5.71-3.81c-0.28-1.09-0.36-2.86-0.36-2.97c0-2.6,0-5.04,1.01-6.69c1.15-1.9,3.33-2.1,4.54-2.1
			c2.41,0,3.56,1.01,4.28,2.1c0.9,1.32,0.9,2.72,0.9,6.55H385.33z M389.11,45.44c0-2.24-0.03-3.95-1.99-3.95
			c-1.85,0-1.82,2.07-1.79,3.95H389.11z"
        />
        <path
          d="M397.62,39.42l2.13,7.31h0.22l1.82-7.31h3.84l-3.7,13.75c-1.37,5.07-2.97,5.99-6.02,5.99c-0.95,0-1.26-0.06-1.93-0.2v-3.3
			l1.43,0.17c1.37,0,1.85-0.7,2.04-1.01c0.5-0.76,0.5-1.15,0.5-2.02l-4.23-13.38H397.62z"
        />
        <path d="M406.75,49.87h4.28v4.4h-4.28V49.87z" />
      </g>
    </g>
  </svg>
);

export default GridAddendum;
